<template>
  <el-switch
    v-bind="$attrs"
    v-on="$listeners"
    active-color="#13ce66"
    inactive-color="#ff4949"
    :active-value="option[1].value"
    :inactive-value="option[0].value"
  >
  </el-switch>
</template>

<script>
  import {getDictList} from '@/utils/getDictDataList.js'
  export default {
    name: "ct-switch",
    props: {
      codeType: String,
    },
    data() {
      return {
        option: []
      }
    },
    created() {
      this.option = getDictList(this.codeType)
      console.log("432",this.option)

    },
  }
</script>

<style scoped>

</style>
